import Link from 'next/link';
import { useRouter } from 'next/router';

import Button from '@/v2/components/Button/Button';

interface LoginMenuButtonProps {
  onClickButton?: () => void;
}

export default function LoginMenuButton({
  onClickButton,
}: LoginMenuButtonProps) {
  const router = useRouter();
  const isLoginPage = router.pathname == '/login';

  const buttonProps = {
    size: 'large' as const,
    onClick: onClickButton,
  };

  if (isLoginPage) {
    return (
      <Button
        {...buttonProps}
        onClick={onClickButton}
        style={{ visibility: 'hidden' }}
      >
        Login
      </Button>
    );
  }

  return (
    <Link href="/login">
      <Button size="large" onClick={onClickButton} block>
        Login
      </Button>
    </Link>
  );
}
